<template>
	<!-- 废弃 -->
	<div class="page-add page">
		<div class="searchBox" style="height: 126px;">
			<el-form>
				<el-row>
					<el-col :span="5" >
						<el-form-item label="出库单号 :" :label-width="'80px'">
							{{detail.outOrderNo}}
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="出库人 :" :label-width="'80px'">
							{{detail.outUserName}}
						</el-form-item>
					</el-col>
					<el-col :span="5" >
						<el-form-item label="出库日期 :" :label-width="'85px'">
							{{this.$public.FTime(detail.outDate)}}
						</el-form-item>
					</el-col>
					<el-col :span="5" >
						<el-form-item label="出库类型 :" :label-width="'85px'">
							{{detail.outOrderType&&detail.outOrderType.name}}
						</el-form-item>
					</el-col>
					<el-col :span="1" :offset="3">
						<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="5" >
						<el-form-item label="去往门店 :" :label-width="'85px'">
							{{detail.otherShopName}}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="备注 :" :label-width="'80px'">
							{{detail.remark}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div style="background-color: #fff;margin-top:20px;padding:20px 30px;min-height: 500px;">
			<el-table :data="tableData" style="width: 100%; margin-top: 10px" :header-cell-style="{color: '#000000',background: '#f5f5f5',fontWeight: '700',}" ref="table" >
				<el-table-column label="名称" prop="goodsName">
				</el-table-column>
				<el-table-column label="规格">
					<template slot-scope="scope">
						<span>{{ scope.row.skuValue }}</span>
					</template>
				</el-table-column>
				<el-table-column label="单位">
					<template slot-scope="scope">
						<span>{{ scope.row.unit }}</span>
					</template>
				</el-table-column>
				<el-table-column label="数量">
					<template slot-scope="scope">
						{{scope.row.goodsList.length}}
					</template>
				</el-table-column>
				<el-table-column type="expand" width="1">
					<template slot-scope="scope">
						<el-table v-show="false" :data="scope.row.goodsList">
							<el-table-column prop="count">
							</el-table-column>
						</el-table>
						<div style="display: inline-block;" v-for="(item,index) in scope.row.goodsList" :key="index">
							<el-tag style="margin: 5px">
								{{ item.customCode }}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button icon="el-icon-view" type="text" @click="toogleExpand(scope.row)">查看条码</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				detail:{},
				tableData:[]
			};
		},
		mounted() {
			this.getDetail();
		},
		methods: {
			// 提交
			getDetail() {
				let params = {
					orderId:this.$route.query.id
				}
				let loading = this.$loading();
				this.$http.get(process.env.VUE_APP_Url3 + 'api/Warehouse/OutOrder/detail', params).then((res) => {
					loading.close();
					if (res.code == 0) {
						this.detail = res.data;
						this.formatTableData(this.detail.outOrderItems)
					}
				});
			},
			formatTableData(outOrderItems){
				let list = []
				let arr_goodsNameSkus = []
				for(let i=0;i<outOrderItems.length;i++){
					let goodsNameSkus = outOrderItems[i].goodsId + outOrderItems[i].skus;
					let index = arr_goodsNameSkus.indexOf(goodsNameSkus);
					if(index===-1){
						arr_goodsNameSkus.push(goodsNameSkus)
						outOrderItems[i].goodsList=[JSON.parse(JSON.stringify(outOrderItems[i]))]
						list.push(outOrderItems[i])
					}else{
						list[index].goodsList.push(outOrderItems[i])
					}
				}
				this.tableData = list;
			},
			toogleExpand(row) {
				let $table = this.$refs.table;
				this.tableData.map((item) => {
					if (row.skus != item.skus) {
						$table.toggleRowExpansion(item, false);
					}
				});
				$table.toggleRowExpansion(row);
			},
		},
	};
</script>
<style lang="scss">
	.page-add {
		.wrapper {
			.tit {
				font-size: 16px;
				margin-bottom: 28px;
				background-color: #f5f5f5;
				height: 40px;
				line-height: 40px;
				border-radius: 3px;

				.name {
					margin-left: 20px;
				}

				.day {
					color: #666;
				}
			}
		}
	}

	.row-expand-cove .el-table__expand-icon {
		display: none;
	}

	.el-table .sort-caret.descending {
		border-top-color: #000;
	}

	.el-table .sort-caret.ascending {
		border-bottom-color: #000;
	}
</style>
